import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M7 10h10v4h-10l0 -4","key":"svg-1"}]]

const IconCircleRectangle = createReactComponent('outline', 'circle-rectangle', 'CircleRectangle', __iconNode);

export default IconCircleRectangle;